import { initialState, RootState } from '@store/index';
import { createSelector } from '@ngrx/store';
import { MenusResolver } from '@services/resolvers/menus/menus-resolver';
import { CmsPageSelectors } from '@store/cms-pages';

import { DEFAULT_CMS_PAGE_METAS, LanguagesEnum, TLanguage } from '@core/config';

export namespace PageMetasSelectors {
  export const selectState = (state: RootState = initialState) => state.pageMetas;

  export const selectPageMetas = createSelector(selectState, state => state.metas || DEFAULT_CMS_PAGE_METAS);

  export const selectTitle = createSelector(selectPageMetas, metas => metas?.title || DEFAULT_CMS_PAGE_METAS.title);

  export const selectJsonLd = createSelector(selectPageMetas, metas => metas?.jsonLd);

  export const selectCurrentLanguage = (lowercase = false) =>
    createSelector(selectState, state => {
      const selectedLanguage: TLanguage = state.selectedLanguage || LanguagesEnum.EN;
      return lowercase ? selectedLanguage.toLowerCase() : selectedLanguage;
    });

  export const selectMainNavItems = createSelector(
    selectState,
    selectCurrentLanguage(),
    (state, language) => state.nav?.main?.[language] ?? null
  );

  export const selectCurrentFooterConfig = createSelector(
    selectState,
    selectCurrentLanguage(),
    (state, language) => state.nav.footer?.[language] ?? null
  );

  export const selectCurrentMainNavConfig = createSelector(selectMainNavItems, items => {
    return items ? MenusResolver.getMainNavConfig(items) : null;
  });

  export const selectBreadcrumbs = createSelector(CmsPageSelectors.selectCurrentCmsPage, page => {
    return page?.breadcrumbs || [];
  });

  export const selectNewsletterCtaEnabled = createSelector(CmsPageSelectors.selectCurrentCmsPage, page => {
    return page?.newsletterCta ?? false;
  });

  export const selectWidgetSettings = createSelector(PageMetasSelectors.selectState, state => state.widget);
}
